import { render, staticRenderFns } from "./BaseButtons.vue?vue&type=template&id=226af466&scoped=true"
import script from "./BaseButtons.vue?vue&type=script&lang=js"
export * from "./BaseButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226af466",
  null
  
)

export default component.exports